import {ApiStatus, ITag} from '../../models';
import {TagsActionTypes, TagsAction} from '../actions/tagActions';

export const initialTagState: ITagState = {
  loadingStatus: null,
  creatingStatus: null,
  deletingStatus: null,
  updatingStatus: null,
  tags: []
}

export interface ITagState {
  loadingStatus: ApiStatus | null;
  creatingStatus: ApiStatus | null;
  deletingStatus: ApiStatus | null;
  updatingStatus: ApiStatus | null;
  tags: ITag[];
}

export default function tagsReducer(state: ITagState = initialTagState, action: TagsAction): ITagState {
  switch (action.type) {
    case TagsActionTypes.LOAD_TAGS:
      return {
        ...state,
        loadingStatus: ApiStatus.LOADING
      };
    case TagsActionTypes.LOADING_TAGS_FAILED:
      return {
        ...state,
        loadingStatus: ApiStatus.FAILED
      };
    case TagsActionTypes.LOADED_TAGS:
      return {
        ...state,
        loadingStatus: ApiStatus.LOADED,
        tags: action.payload.tags
      };
    case TagsActionTypes.CLEAR_TAGS:
      return {
        ...state,
        tags: []
      };
    case TagsActionTypes.CREATE_TAG:
      return {
        ...state,
        creatingStatus: ApiStatus.LOADING
      };
    case TagsActionTypes.CREATING_TAG_FAILED:
      return {
        ...state,
        creatingStatus: ApiStatus.FAILED
      };
    case TagsActionTypes.CREATED_TAG:
      return handleCreatedTag(state, action);
    case TagsActionTypes.UPDATE_TAG:
      return {
        ...state,
        updatingStatus: ApiStatus.LOADING
      };
    case TagsActionTypes.UPDATING_TAG_FAILED:
      return {
        ...state,
        updatingStatus: ApiStatus.FAILED
      };
    case TagsActionTypes.UPDATED_TAG:
      return handleUpdatedTag(state, action);
    case TagsActionTypes.REMOVE_TAG:
      return {
        ...state,
        deletingStatus: ApiStatus.LOADING
      };
    case TagsActionTypes.REMOVING_TAG_FAILED:
      return {
        ...state,
        deletingStatus: ApiStatus.FAILED
      };
    case TagsActionTypes.REMOVED_TAG:
      return handleRemovedTag(state, action);
    default:
      return state;
  }
}

function handleCreatedTag(state: ITagState, action: any): ITagState {
  let tags = state.tags || [];
  const {tag} = action.payload;

  const found = tags.find((t: ITag) => t.uid === tag.uid);

  if (!found) {
    tags = [
      ...tags,
      tag,
    ]; // append newly created tag to tags list
  }

  return {
    ...state,
    tags: tags,
    creatingStatus: ApiStatus.LOADED,
  };
}

function handleRemovedTag(state: ITagState, action: any): ITagState {
  let tags = state.tags || [];
  if (!action.payload.parent) {
    /*
     * This means that the tag was deleted, not removed from an object.
     */
    tags = tags.filter((t: ITag) => t.uid !== action.payload.uid);
  }
  return {
    ...state,
    tags: tags,
    deletingStatus: ApiStatus.LOADED
  };
}

function handleUpdatedTag(state: ITagState, action: any): ITagState {
  let tags = state.tags || [];
  const {uid, tag} = action.payload;

  tags = tags.map((t: ITag) => {
    const found = t.uid === uid;

    if (found) {
      return {
        ...t,
        name: tag.name,
      }
    }

    return t;
  });

  return {
    ...state,
    tags: tags,
    updatingStatus: ApiStatus.LOADED,
  };
}
